import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { ShareLinkFormType } from '../link-config-form.factory';
import { SharePanelFormSection } from './section';

const SharePanelFormEmailParamsSectionLink = () => {
  const { values } = useFormikContext<ShareLinkFormType>();

  const subtitle: string = useMemo(() => {
    if (values.email_param_enabled) {
      return 'Email parameter capture is enabled';
    }
    return 'Capture email parameters from URL';
  }, [values.email_param_enabled]);

  return <SharePanelFormSection type='email-params' title='Email Get Parameter' subTitle={subtitle} />;
};

export default SharePanelFormEmailParamsSectionLink; 